export default "__VITE_ASSET__DCT$7tGG__"